import React, { Component } from "react";
import GetProductionJsonModal from "./Modal/GetProductionJsonModal";
import ProductionListModal from "./Modal/ProductionListModal";
import PostProductionJsonModal from "./Modal/PostProductionJsonModal";
import AddToCartProductListModal from "./Modal/AddToCartProductListModal";

export default class AllModalWrap extends Component {
    render() {
        const {
            // function
            updateShowGetProductionJsonModal,
            updateShowProductionListModal,
            updateShowPostProductionJsonModal,
            updateShowAddToCartProductListModal,
            getSaveStatusApi,
            // variable
            isShowResult,
            listData,
            isShowGetProductionJsonModal,
            isShowProductionListModal,
            isShowPostProductionJsonModal,
            isShowAddToCartProductListModal,
            selectedCategoryIndex,
            selectedState,
            saveJson,
            isLoading,
            readyAddToCartList,
            alreadyAddToCartList,
        } = this.props;

        return (
            <div className="allModalWrap">
                <GetProductionJsonModal
                    updateShowGetProductionJsonModal={
                        updateShowGetProductionJsonModal
                    }
                    isShowGetProductionJsonModal={isShowGetProductionJsonModal}
                    getSaveStatusApi={getSaveStatusApi}
                />
                <ProductionListModal
                    listData={listData}
                    updateShowProductionListModal={
                        updateShowProductionListModal
                    }
                    isShowProductionListModal={isShowProductionListModal}
                />
                <PostProductionJsonModal
                    selectedCategoryIndex={selectedCategoryIndex}
                    selectedState={selectedState}
                    updateShowPostProductionJsonModal={
                        updateShowPostProductionJsonModal
                    }
                    isShowPostProductionJsonModal={
                        isShowPostProductionJsonModal
                    }
                    saveJson={saveJson}
                />
                <AddToCartProductListModal
                    isShowResult={isShowResult}
                    isLoading={isLoading}
                    readyAddToCartList={readyAddToCartList}
                    alreadyAddToCartList={alreadyAddToCartList}
                    listData={listData}
                    isShowAddToCartProductListModal={
                        isShowAddToCartProductListModal
                    }
                    updateShowAddToCartProductListModal={
                        updateShowAddToCartProductListModal
                    }
                />
            </div>
        );
    }
}
